import { selectComponent } from './select.component';

export const selectStateName = 'app.ticket.select';

export const selectState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: selectStateName,
    url: '/select',
    component: selectComponent.name,
    data: { requiresAuth: true },
    resolve: {
      maybeRedirectToNewUi: (appConfig, $window, envService) => {
        const { ui } = appConfig;
        if (ui.v2UI.oldBank && !envService.isLocalhost()) {
          $window.location.href = $window.location.href.replace(
            '/tickets',
            '/v2/tickets',
          );
        }
      },
    },
  });
};
